import React from "react";

import styled from "styled-components";
// import { Button, Popover } from "antd";
import { GlassCard } from "components/App/styled";
import colors from "constants/palette";

const week = [
  "يكشنبه",
  "دوشنبه",
  "سه شنبه",
  "چهارشنبه",
  "پنج شنبه",
  "جمعه",
  "شنبه",
];

export default function DateTime(params) {
  const [date, setDate] = React.useState(new Date());

  // console.log("getday", date.getDay());
  React.useEffect(() => {
    const timerId = setInterval(() => setDate(new Date()), 1000);
    return function cleanup() {
      clearInterval(timerId);
    };
  }, []);

  return (
    <Container>
      <Item>
        <Time>
          {date.toLocaleTimeString("en-ir", { hour12: false }).slice(0, 5)}
        </Time>
        <DateText>{date.toLocaleDateString("fa-ir")}</DateText>
        <DateText>{date.toLocaleDateString()}</DateText>
      </Item>
      <Item>
        <Day
          onClick={() => {
            var KICKASSVERSION = "2.0";
            var s = document.createElement("script");
            s.type = "text/javascript";
            document.body.appendChild(s);
            s.src = "//hi.kickassapp.com/kickass.js";
            void 0;
          }}
        >
          {week[date.getDay()]}
        </Day>
      </Item>
    </Container>
  );
}

const Container = styled(GlassCard)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 86%;
  padding: ${colors.bgImage ? "0 3%" : "0"};
  color: ${colors.dark};
  @media (max-width: 720px) {
    flex-direction: column-reverse;
  }
`;
const Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Time = styled.span`
  font-size: 2rem;
  font-weight: bolder;
  font-family: fantasy;
  letter-spacing: 2px;
  @media (max-width: 720px) {
    display: none;
  }
`;
const Day = styled.a`
  font-size: 1.5rem;
  margin-right: 32px;
  font-weight: bolder;
  color: ${colors.dark};
  @media (max-width: 720px) {
    margin-right: 0;
    font-size: 1.3rem;
  }
`;
const DateText = styled.span``;
